export { default as useModalDelete } from './useModalDelete';
